import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import {
	CLIENT_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { IClient, IGetListRequest } from "../../../models";
import { IResponse, IServerError } from "../../../models/common";
import { Link, useNavigate } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { formatPhoneNo, useNavigateToLogout } from "../../../common/Common";
import {
	setAppBarSelectedItem,
	setSelectedActivityLogActions,
	setSelectedClient,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AccountantService } from "../../../services";
import { IAppState } from "../../../store/reducers";
import { PrimeDataGrid } from "../../PrimeDataGrid";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";

export interface IClientList { }
const CLIENT_LIST_QUERY_KEY: any = "clients-list";

const useClients = (
	accountantId: string,
	isAdminUser: number,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: ["clients-list", accountantId, isAdminUser, params],
		queryFn: () => AccountantService.getClientByAccountantId(
			accountantId,
			isAdminUser,
			params,
			navigateToLogout
		),
		// refetchOnWindowFocus: false

		// ####################################FOR SLOW PAGGING ISSUE 100 #####################################
		staleTime: 0,              // always stale
		gcTime: 0,                 // no cache persistence
		refetchOnMount: "always",  // always refetch
		refetchOnWindowFocus: false,
	});

export const ClientList: React.FC<IClientList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "legalName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { id } = useSelector((state: IAppState) => state.accountant);
	const { isPending, data } = useClients(
		String(id),
		isAdminUser,
		queryParams,
		navigateToLogout
	); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const clientList: any | null = data;


	if (clientList && clientList.message == "UnAuthrized") {
		let path = "logout";
		navigate(path);
	}
	useEffect(() => {
		if (
			clientList &&
			clientList.items &&
			clientList.items.length === 1 &&
			zeroClient === true
		) {
			// dispatch(setSelectedClient(clientList.items[0]));
			if (clientIdStore && clientIdStore !== "") {
				let path = "/clients/dashboard";
				navigate(path);
			}
		}
		if (
			clientList &&
			clientList.message &&
			clientList.message.detail === "Invalid token or expired token."
		) {
			let path = "/logout";
			navigate(path);
		}
	}, [clientList]);

	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);
	const [searchText, setSearchText] = useState({});
	const [zeroClient, setzeroClient] = useState(true);
	const [clientListUpdatedItems, setClientListUpdatedItems] =
		useState<any>(undefined);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [clientId, setClientId] = useState<any>(0);

	// Bulk Delete
	const [bulkDelete, setBulkDelete] = useState<boolean>(false);
	const [bulkClientId, setBulkClientId] = useState<any>({});
	const [bulkClientDelete, setBulkClientDelete] = useState<boolean>(false);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by: "legalName",
			order_direction:
				requestParams.sortField !== null
					? requestParams.sortField
					: requestParams.sortOrder
						? requestParams.sortOrder
						: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onSearchButtonClicked = () => {
		setQueryParams(searchText);
		setzeroClient(false);
	};

	const onRowEditClicked = useCallback((params: IClient) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		dispatch(setSelectedClient({ superUserFieldsShownInClientSetup: true }));
		let path = `/clients/setup/${params.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteClientField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let payload: any = {
				clientId: clientId,
				navigateToLogout: navigateToLogout,
			};
			deleteClientById(payload);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: IClient) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setClientId(params.id);

		// alert(`Delete row with ID: ${params.row.id} has been clicked!`);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteClientById } = useMutation({
		mutationFn: AccountantService.delClient,
		onSuccess: (res: string | IServerError | IResponse | any) => {

			if (res) {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : res.success === false ? "error" : "success",
				});

				if (res.success !== false) {
					return queryClient.invalidateQueries(CLIENT_LIST_QUERY_KEY);
				}
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	}
	);

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	const onKeyFieldClickHandler = (clickedRow: any) => {
		dispatch(setSelectedClient(clickedRow));
		// dispatch(setSelectedClientName(clickedRow));
	};

	//bulk delete

	const { isPending: isBulkDeleting, mutate: deleteBulkClientes } = useMutation({
		mutationFn: AccountantService.delBulkClientes,
		onSuccess: (res: any | string | IServerError | IResponse) => {
			if (typeof res === "object") {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong.",
					severity: res.status === false ? "error" : "success",
				});

				setBulkClientDelete(false);
				return queryClient.invalidateQueries(CLIENT_LIST_QUERY_KEY);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			setBulkClientDelete(false);
		},
		onError: (err: any) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
			setBulkClientDelete(false);
		},
	}
	);

	// For Bulk Delete
	const deleteBulkClientField = () => {
		if (bulkDelete) {
			setBulkDelete(false);
			let payload = {
				clientIds: bulkClientId,
				navigateToLogout: navigateToLogout,
			};
			deleteBulkClientes(payload);
			setDialogOpen(false);
		}
	};

	const onRowMultipleDeleteClicked = (params: any) => {

		let bulkDeletePayload = {
			clientIds: { clientIds: params },
		};
		setDialogOpen(true);
		setBulkDelete(true);
		setApiAction("delete");
		setBulkClientId(bulkDeletePayload);
		setBulkClientDelete(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				// <Box sx={{ marginTop: theme.spacing(1) }}>
				// 	<Button
				// 		onClick={() => onRowMultipleDeleteClicked(selectedItems)}
				// 		variant="contained"
				// 		color="error"
				// 	>
				// 		Delete
				// 	</Button>
				// </Box>
				<></>
			);
		}
		return (
			// <Box sx={{ marginTop: theme.spacing(1) }}>
			// 	<RouterLinkButton to="/clients/setup" text="Add Client" />
			// </Box>
			<></>
		);
	}, []);

	const onClickHandler = (clickedRow: any) => {
		// dispatch(setSelectedClient(clickedRow));
		if (accountantId) {
			dispatch(
				setSelectedClient({
					...clickedRow,
					superUserFieldsShownInClientSetup: true,
				})
			);
		} else {
			dispatch(setSelectedClient(clickedRow));
		}
		dispatch(setAppBarSelectedItem({ appBarSelectedItem: "Home" }));
	};

	const upadtedClientListItems = useMemo(() => {
		return (
			clientList &&
			clientList.items &&
			clientList?.items.map((item: any) => ({
				...item,
				legalName: (
					<Link
						to={`/clients/dashboard`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => onClickHandler(item)}
					>
						{item.legalName}
					</Link>

				),
				phone1: (
					<Typography
						sx={{
							fontSize: "0.875rem",
							userSelect: "text !important",
							WebkitUserDrag: "none",
						}}
					>
						{formatPhoneNo(item.phone1)}
					</Typography>
				),
				email: item.email?.charAt(2) === "*" ? "Unmask to view" : item.email,
			}))
		);
	}, [clientList]);


	// const enhanceData = (data: any[]): any[] => {
	// 	return data.map((item) => {
	// 		const enhancedItem = {
	// 			...item,
	// 			expanded: item.label === "Home" ? true : false,
	// 		};
	// 		return enhancedItem;
	// 	});
	// };

	const expandedLabels = ["Home"];
	const expandedHomeClientListOrClientListItem = "Client List"; // Special case for "ClientList" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Home" &&
				item.label === expandedHomeClientListOrClientListItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				// expanded: false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: parentLabel === "Home" && item.label === expandedHomeClientListOrClientListItem && "/accountants/clients"
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: CLIENT_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	const onAddClientClickedHandler = () => {
		dispatch(setSelectedClient({ superUserFieldsShownInClientSetup: true }));
		let path = '/clients/setup'
		navigate(path)
	}

	return clientList &&
		clientList.items &&
		clientList.items.length === 0 &&
		zeroClient === true ? (
		<><EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Client to proceed`}
			content={`You can add client by directly clicking on add client button.`}
			testId={"client-empty-list"}
			showAddButton={false}
			// addButtonLabel={"Add Client"}
			// navigateToAdd={"/clients/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
			<div style={{ background: "#fff", justifyContent: "center", alignItems: "center", display: "flex", paddingBottom: "1rem" }}>
				<Button variant="outlined" onClick={onAddClientClickedHandler} sx={{ textTransform: "capitalize", fontWeight: "bold" }}>
					Add Client
				</Button>
			</div>
		</>

	) : (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending || isDeleting || isBulkDeleting
					}
					testId="resource list"
				/>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={
						bulkClientDelete === true
							? deleteBulkClientField
							: deleteClientField
					}
					cancelActionHandler={onCloseHandler}
					testId="tax-profile-tab-confirmation-dialog"
				/>
				<PrimeDataGrid
					columns={clientList ? clientList.headerColumns : []}
					rows={
						clientList && upadtedClientListItems ? upadtedClientListItems : []
					}
					showIndexColumn={true}
					// showChecboxColumn={isAdminUser === 400 ? true : false}
					showChecboxColumn={false}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={isPending || isDeleting || isBulkDeleting}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={clientList && clientList.total ? clientList.total : 0}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by Client Name..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroClient(value)
					}
					pageTitle={"Clients"}
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
